import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import CommonListView from "../../common/CommonListView/CommonListView";
import {ImageUrl} from '../../../utils/constants'
import { UserInitialsMain } from "../../SocialFeedsV2/styles";
import { commaSeperator, getInitials } from "../../../utils/methods";


/* ---------------- Styled Components ---------------- */

const UserCell = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const UserImage = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  .profileImg{
    width: 48px;
    height: 48px;
    border-radius: 50%;
    object-fit: cover;
  }
`;

const UserName = styled.span`
  color: #184A61;
  font-family: Lato;
  font-size: 18px;
  font-weight: 700;
`;

const TextCell = styled.div`
  color: #184A61;
  font-family: Lato;
  font-size: 16px;
`;

const DateTextCell = styled.div`
  color: #184A61;
  font-family: Lato;
  font-size: 16px;
  text-align: end;
`;

const Points = styled.div`
  font-family: Lato;
  font-size: 16px;
  ${'' /* font-weight: 700; */}
  ${'' /* color: #DA6C74; */}
  color: #184A61;
`;

/* ---------------- Headers ---------------- */

const headers = [
  { key: "user", label: "Name", align: "start" },
  { key: "department", label: "Department" },
  { key: "location", label: "Location" },
  { key: "points", label: "Spot Points" },
  { key: "date", label: "Date" , align: "end" }
];

/* ---------------- Component ---------------- */

const SpotRewardsListView = ({ rewards = [] ,leaders=[] }) => {


  window.console.log("rewards",rewards);  


  const renderCell = (key, row) => {

    const containsDefaultPng = (path) => path === "profile-Image/default.png";


    if (key === "user") {
      return (
        <UserCell>
          {/* <UserImage src={ImageUrl + "/" + row.profile_image} /> */}
        
          <UserImage >
            {!containsDefaultPng(row?.profile_image) ? (
              <img className="profileImg" src={`${ImageUrl}/${row?.profile_image}`} />
            ) : (
              <UserInitialsMain color={"#184A61"} isBg border size="16px">
                {getInitials(row?.name)}
              </UserInitialsMain>
            )}
          </UserImage>
          <UserName>{row.name}</UserName>
        </UserCell>

      );
    }

    if (key === "department") {
      return <TextCell>{row.department}</TextCell>;
    }

    if (key === "location") {
      return <TextCell>{row.location}</TextCell>;
    }

    if (key === "points") {
      return <Points>{commaSeperator(row.points_received)}</Points>;
    }

    if (key === "date") {
      return <DateTextCell>{row.awarded_at}</DateTextCell>;
    }

    return null;
  };

  return (
    <CommonListView
      headers={headers}
      // data={rewards}
      data={leaders}
      // grid="1.4fr 1.5fr 1.5fr 1fr 0.2fr"
      grid="2fr 1.2fr 1.2fr 0.8fr 1fr"
      renderCell={renderCell}
    />
  );
};

/* ---------------- PropTypes ---------------- */

SpotRewardsListView.propTypes = {
  rewards: PropTypes.array,
  leaders: PropTypes.array
};

export default SpotRewardsListView;